import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Terren
 * id 13BC9B18-661D-4517-84E9-756EC2536F4E
 * name file-multiple-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-multiple-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileMultipleOutlineIcon = createSvgIcon(<><path d="M16 0H8C6.9 0 6 .9 6 2V18C6 19.1 6.9 20 8 20H20C21.1 20 22 19.1 22 18V6L16 0M20 18H8V2H15V7H20V18M4 4V22H20V24H4C2.9 24 2 23.1 2 22V4H4Z" /></>, 'FileMultipleOutlineIcon');
export default FileMultipleOutlineIcon